module.exports = __webpack_public_path__ + "img/APSCHE.9277fe44.jpg";